import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';

const screenWidth = window.screen.width;

class InsiderTradingFull extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            symbol: this.props.symbol,
            limit: this.props.limit
        };
    }

    custom_sort(a, b) {
        return new Date(a.filingDate).getTime() - new Date(b.filingDate).getTime();
    }

    componentDidMount() {
        console.log('screenWidth', screenWidth);
        ApiService.getInsiderTrading(this.state.symbol, this.state.limit)
            .then(result => {
                console.log('Insider Trading', result);
                let filteredData = [];
                let newFilteredData = [];
                let length = this.state.limit;
                let tmpLength = 1000;
                if (result.length > 0) {
                    tmpLength = result.length < tmpLength ? result.length : tmpLength;
                    for (var i = 0; i < tmpLength; i++) {
                        if (result[i].transactionType === 'S-Sale' || result[i].transactionType === 'P-Purchase') {
                            filteredData.push(result[i]);
                        }
                    }

                    length = filteredData.length < length ? filteredData.length : length;
                    console.log('filteredData', filteredData, length);

                    for (i = 0; i < length; i++) {
                        if (filteredData[i].transactionType === 'S-Sale') {
                            filteredData[i].transactionType = 'Sale';
                        }
                        if (filteredData[i].transactionType === 'P-Purchase') {
                            filteredData[i].transactionType = 'Buy';
                        }
                        filteredData[i].typeOfOwner = filteredData[i].typeOfOwner.replace('officer: ', '');
                        filteredData[i].typeOfOwner = filteredData[i].typeOfOwner.replace('director, ', '');

                        newFilteredData.push(filteredData[i]);
                    }
                }
                this.setState({ list: newFilteredData });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.symbol !== undefined) {
            let url = '/chart/' + listValue.symbol;
            let resultColor = '';
            if (listValue.transactionType.toLowerCase().startsWith('sale')) {
                resultColor = 'red';
            } else if (listValue.transactionType.toLowerCase().startsWith('buy')) {
                resultColor = 'green';
            }
    

            return (
                <tr key={listValue.symbol + listValue.link + listValue.filingDate + listValue.reportingName + listValue.price + listValue.securitiesOwned + listValue.securitiesTransacted}>
                    <td style={{ color: resultColor}}><Link to={url}>{listValue.symbol}</Link></td>
                    <td style={{ color: resultColor}}>{listValue.filingDate}</td>
                    <td style={{ color: resultColor}}>{listValue.reportingName}</td>
                    <MediaQuery minWidth={500}>
                        <td style={{ color: resultColor}}>{listValue.typeOfOwner}</td>
                        <td style={{ color: resultColor}}>{listValue.transactionType}</td>
                        <td style={{ color: resultColor}}>{listValue.price}</td>
                    </MediaQuery>
                    <td style={{ color: resultColor}}>{listValue.securitiesTransacted}</td>
                    <MediaQuery minWidth={500}>
                        <td style={{ color: resultColor}}>{parseFloat(listValue.price * listValue.securitiesTransacted).toFixed(0)}</td>
                        <td style={{ color: resultColor}}>{parseFloat(listValue.securitiesOwned).toFixed(0)}</td>
                    </MediaQuery>
                </tr>
            )
        }
    }

    render() {
        let tableRow;
        if (this.state.list === undefined || this.state.list.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
        } else {
            tableRow = this.state.list.map(this.renderRow.bind(this));
        }
        return (
            <div>              
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th>Ticker</th>
                            <th>Date</th>
                            <th>Name</th>
                            <MediaQuery minWidth={500}>
                                <th>Position</th>
                                <th>Transaction</th>
                                <th>Price</th>
                            </MediaQuery>
                            <th>Shares#</th>
                            <MediaQuery minWidth={500}>
                                <th>Value</th>
                                <th>Total Sh#</th>
                            </MediaQuery>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default InsiderTradingFull;
